import { UnstyledButton } from '@src/components/base/Buttons'
import * as React from 'react'
import styled from 'styled-components'

export const TriggerContainer = styled.div`
  display: flex;
  align-items: center;
`

export const TriggerText = styled(UnstyledButton)<{ underline?: boolean }>`
  cursor: pointer;
  color: ${({ theme }) => theme.colors.dark};
  font-size: ${({ theme }) => theme.font.text.size.sm};
  margin-left: ${({ theme }) => theme.spacing.xs};

  ${({ underline }) => (underline ? 'text-decoration: underline;' : '')}
  &:hover {
    text-decoration: underline;
  }
`

export const MenuItem = styled(UnstyledButton)<{ disabled?: boolean; to?: string }>`
  padding: ${({ theme }) => theme.spacing.sm} ${({ theme }) => theme.spacing.md};
  font-size: ${({ theme }) => theme.font.text.size.sm};};
  line-height: 17px;
  display: flex;
  width: 160px;
  color: ${({ theme }) => theme.colors.dark};
  opacity: ${props => (props.disabled ? 0.5 : 1)};
  cursor: pointer;
  pointer-events: ${props => (props.disabled ? 'none' : 'auto')};
  box-sizing: border-box;
  &:hover {
    background-color: ${({ theme }) => theme.colors.skyXlight};
    width: 100%;
  }
`

export const MenuWrapper = styled.div`
  display: flex;
  flex-direction: column;
  width: fit-content;
  border: 1px solid ${({ theme }) => theme.colors.greyLight};
  background-color: ${({ theme }) => theme.colors.white};
  box-shadow: 0 4px 16px 0 rgba(0, 0, 0, 0.08);
`

export const TabList: React.FunctionComponent<{ children: React.ReactNode }> = ({
  children,
}) => <MenuWrapper role="tablist">{children}</MenuWrapper>



// WEBPACK FOOTER //
// ./src/layouts/shared/styles.tsx